"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SPEED_SCREEN_FORM_LAYOUT = exports.DEFAULT_SCHEME_COLUMN_COUNT = exports.DEFAULT_TCI_LEVELS = exports.DEFAULT_SCHEME_STATE = void 0;
exports.DEFAULT_SCHEME_STATE = {
    analytics: true,
    events: true,
    information: true,
    measures: true,
    points: true,
    stateAndForecast: true,
    tables: true,
    toir: true,
    train: true,
};
exports.DEFAULT_TCI_LEVELS = {
    warning: 70,
    critical: 50,
};
exports.DEFAULT_SCHEME_COLUMN_COUNT = "2";
exports.DEFAULT_SPEED_SCREEN_FORM_LAYOUT = "1";
//# sourceMappingURL=constants.js.map